<template>
  <div class="header">
    <div class="bg_header tophead">
      <dv-decoration-8 class="header-left-decoration" />
      
      <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    </div>
    <div class="bg_header bthead">
      <div class="time">{{ showTime(date) }}</div>
      
      <dv-decoration-11 class="t_title" >{{title}}</dv-decoration-11>
      <div class="ad">
        <span
          >{{ weatherData.province || "" }}&nbsp;&nbsp;{{
            weatherData.city || ""
          }}&nbsp;&nbsp;</span
        >
        <span>{{ weatherData.weather || "晴" }}&nbsp;&nbsp;</span>
        <span>湿度：{{ weatherData.humidity || "0" }}%</span>
      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  props: {
    title: {
      type: String,
      default: "再生资源智慧产业园驾驶舱",
    },
    WeatherCode: {
      type: [String, Number],
      default: "",
    },
    
  },
  data() {
    return {
      date: new Date(),
      weatherData: {
        province: "",
        city: "",
        weather: "",
        humidity: "",
      },
    };
  },
  created() {
    this.initAmap();
  },
  mounted() {
    //显示当前日期时间
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.date = new Date(); // 修改数据date
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    //   获取实时时间
    showTime(dateval) {
      let show_day = new Array(
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日"
      );
      let time = new Date(dateval);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let day = time.getDay();
      let hour = time.getHours();
      let minutes = time.getMinutes();
      let second = time.getSeconds();
      month < 10 ? (month = "0" + month) : month;
      //month = month + 1;
      //alert(year);
      hour < 10 ? (hour = "0" + hour) : hour;
      minutes < 10 ? (minutes = "0" + minutes) : minutes;
      second < 10 ? (second = "0" + second) : second;
      let datetime =
        year +
        "." +
        month +
        "." +
        date +
        " " +
        " " +
        show_day[day - 1] +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        second;
      return datetime;
    },

    // 查询天气
    initAmap() {
      let map = null;
      window._AMapSecurityConfig = {
        securityJsCode: "1ea9508fa1c2167add1949949e9c3f96",
      };
      AMapLoader.load({
        key: "f04e75ddb70acbdf462508cf90061476",
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        //plugins:[],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 版本
          plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
        },
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: "2.0", // Loca 版本
        },
      })
        .then((AMap) => {
          AMap.plugin("AMap.Weather", () => {
            //创建天气查询实例
            var weather = new AMap.Weather();

            //执行实时天气信息查询
            weather.getLive(this.WeatherCode, (err, data) => {
              console.log(err, data, "查询的天气数据");
              this.weatherData = data;
            });
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/*header开始*/
.header {
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  color: #fff;
  position: relative;

  .bg_header {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
  }

  .tophead {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
    position: absolute;

    .header-center-decoration {
      width: 50%;
      height: 60px;
      margin-top: 30px;
    }
    .header-left-decoration,
    .header-right-decoration {
      width: 20%;
      height: 60px;
    }
  }

  .bthead {
    padding: 0 50px;
    box-sizing: border-box;
    
    .t_title {
      width: 50%;
      height: 100%;
      text-align: center;
      font-weight: bold;
      letter-spacing: 8px;
      font-size: 34px;
      color: #fff;
    }
  }
}
</style>
